import { useState, useEffect } from "react";
import { radToDeg } from "three/src/math/MathUtils";
import { Group, Text, Button, Image, UnstyledButton } from "@mantine/core";

import transformIcon from "../../static/svg/transform.svg";
import rotateIcon from "../../static/svg/rotate.svg";
import scaleIcon from "../../static/svg/scale.svg";

function TransformControls({
	selectedObject,
	transformControl,
	setSelectedObject,
}) {
	const [selectedControl, setSelectedControl] = useState("translate");
	useEffect(() => {}, [
		JSON.stringify(transformControl?.object?.position),
		JSON.stringify(transformControl?.object?.rotation),
		JSON.stringify(transformControl?.object?.scale),
	]);

	if (!selectedObject) return null;
	const disabled =
		selectedObject?.type === "hotspot" ||
		selectedObject?.type === "text" ||
		selectedObject?.type === "link" ||
		selectedObject?.type === "image" ||
		selectedObject?.type === "video" ||
		selectedObject?.type === "pano" ||
		selectedObject?.type === "three-d" ||
		selectedObject?.type === "audio";
	return (
		<Group
			align={"start"}
			style={{
				height: "96px",
				width: "340px",
				backgroundColor: "#040f1fcc",
				padding: "5px 15px ",
				borderRadius: "5px",
			}}
		>
			<Group
				px={0}
				py={0}
				mx={0}
				my={0}
				direction="row"
				style={{ justifyContent: "space-between", width: "100%" }}
			>
				<Group style={{ gap: "7px" }}>
					<UnstyledButton
						style={{
							padding: "5px",
							border: `${
								selectedControl === "translate"
									? "1px solid #14B8E1"
									: "none"
							}`,
							borderRadius: "5px",
						}}
						onClick={() => {
							setSelectedControl("translate");
							transformControl.setMode("translate");
						}}
					>
						<Image src={transformIcon} width={20} />
					</UnstyledButton>
					<UnstyledButton
						disabled={disabled}
						style={{
							padding: "5px",
							border: `${
								selectedControl === "rotate"
									? "1px solid #14B8E1"
									: "none"
							}`,
							borderRadius: "5px",
							backgroundColor: `${
								disabled ? "gray" : "transparent"
							}`,
							opacity: `${disabled ? "0.5" : "1"}`,
						}}
						onClick={() => {
							setSelectedControl("rotate");
							transformControl.setMode("rotate");
						}}
					>
						<Image src={rotateIcon} width={20} />
					</UnstyledButton>
					<UnstyledButton
						disabled={disabled}
						style={{
							padding: "5px",
							border: `${
								selectedControl === "scale"
									? "1px solid #14B8E1"
									: "none"
							}`,
							borderRadius: "5px",
							backgroundColor: `${
								disabled ? "gray" : "transparent"
							}`,
							opacity: `${disabled ? "0.5" : "1"}`,
						}}
						onClick={() => {
							setSelectedControl("scale");
							transformControl.setMode("scale");
						}}
					>
						<Image src={scaleIcon} width={20} />
					</UnstyledButton>
				</Group>
				<Group>
					<Button
						variant="outline"
						size="xs"
						radius={"md"}
						py={5}
						style={{ fontWeight: "normal", fontSize: "14px" }}
						sx={(theme) => ({
							color: theme.colors.white[0],
							borderColor: theme.colors.ivisit_light[0],
						})}
						onClick={() => {
							setSelectedObject(null);
							transformControl.detach();
							transformControl.setSize(0);
						}}
					>
						Close
					</Button>
				</Group>
			</Group>
			<Group style={{ width: "100%" }}>
				{selectedControl === "translate" ? (
					<>
						<Text>
							x: {transformControl?.object?.position.x.toFixed(2)}
						</Text>
						<Text>
							y: {transformControl?.object?.position.y.toFixed(2)}
						</Text>
						<Text>
							z: {transformControl?.object?.position.z.toFixed(2)}
						</Text>
					</>
				) : null}
				{selectedControl === "rotate" ? (
					<>
						<Text>
							x:{" "}
							{radToDeg(
								transformControl?.object?.rotation.x
							).toFixed(2)}
						</Text>
						<Text>
							y:{" "}
							{radToDeg(
								transformControl?.object?.rotation.y
							).toFixed(2)}
						</Text>
						<Text>
							z:{" "}
							{radToDeg(
								transformControl?.object?.rotation.z
							).toFixed(2)}
						</Text>
					</>
				) : null}
				{selectedControl === "scale" ? (
					<>
						<Text>
							x: {transformControl?.object?.scale.x.toFixed(2)}
						</Text>
						<Text>
							y: {transformControl?.object?.scale.y.toFixed(2)}
						</Text>
						<Text>
							z: {transformControl?.object?.scale.z.toFixed(2)}
						</Text>
					</>
				) : null}
			</Group>
		</Group>
	);
}

export default TransformControls;
